import { COMMON_ACTION_TYPES, TRACK_ACTION_TYPES } from '../../utilities/constants'

const INITIAL_STATE = {
  trackList: {
    isLoading: false,
    data: []
  }

}
const trackReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case TRACK_ACTION_TYPES.GET_TRACK_LIST + COMMON_ACTION_TYPES.REQUEST:
      return {
        ...state,
        trackList: {
          ...state.trackList,
          isLoading: true
        }
      }
    case TRACK_ACTION_TYPES.GET_TRACK_LIST + COMMON_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        trackList: {
          isLoading: false,
          data: action.data
        }
      }
    case TRACK_ACTION_TYPES.GET_TRACK_LIST + COMMON_ACTION_TYPES.ERROR:
      return {
        ...state,
        trackList: {
          isLoading: false,
          data: []
        }
      }
    default:
      return state
  }
}

export default trackReducer
